import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import VendorSelect from "../../../CommonComponents/Select/VendorSelect";
import CustomSelect from "../../../CommonComponents/Select/CustomSelect";
import { ArrowDropDown } from "@mui/icons-material";
import { getLocationList } from "../../../Services/caseManagement.service";
import useToaster from "../../../customHook/useToaster";
import Grid from "@mui/material/Grid";
import CommonButton from "../../../CommonComponents/CommonButton";
import AddIcon from "@mui/icons-material/Add";
import { Typography } from "@mui/material";

const labelStyles = {
  marginBottom: "1rem",
  color: "#3a3a3a",
  fontSize: "1.25rem",
  fontWeight: 500,
};
const dropdownStyles = {
  fontSize: "1.2rem",
  height: "auto",
  ".MuiSelect-select": {
    padding: "8.5px 8px",
  },
  ".MuiSvgIcon-root ": {
    marginRight: "-1rem",
    fontSize: "3rem",
    color: "#7C7C7C",
  },
  ".makeStyles-placeholder": {
    color: "#7C7C7C",
  },
  ".MuiPopover-root.MuiMenu-paper.Mui-focused": {
    borderRadius: "4px 4px 0 0",
  },
};

const menuProps = {
  PaperProps: {
    sx: {
      bgcolor: "#ebeef8",
      borderRadius: "0 0 4px 4px",
    },
  },
};

const LobData = ["Motor", "Health", "Corporate", "Commercial", "Others"];
const ProductData = [
  "Motor OD",
  "Motor TP",
  "Motor Theft",
  "Health Cashless",
  "Health Reimburshment",
  "Health Preauth",
  "Critical Illness",
];

function ServiceDetails({
  setIsBtn1Active,
  setIsBtn2Active,
  saveClicked,
  nextClicked,
  onSaveClick,
  onNextClick,
}) {
  const [lobSelectedValue, setLobSelectedValue] = useState([]);
  const [productSelectedValue, setProductSelectedValue] = useState([]);
  const [dropdownData, setDropdownData] = useState([]);
  const [addLocation, setAddLocation] = useState([{}]);

  const { showToast } = useToaster();
  const formContents = [
    {
      name: "state",
      type: "Select",
      placeholder: "Select State",
      options: [...dropdownData?.map((obj) => obj?.state)],
    },
  ];

  const onChangeHandler = (value, name, id) => {
    setAddLocation((prev) => {
      prev[id][name] = value;
      return [...prev];
    });
  };

  const addLocationHandler = () => {
    const locationDropdownArray = [...addLocation, []];
    setAddLocation(locationDropdownArray);
  };

  useEffect(() => {
    if (saveClicked) onSaveClick();
    if (nextClicked) onNextClick();
  }, [saveClicked, nextClicked]);

  useEffect(() => {
    if (addLocation && lobSelectedValue && productSelectedValue) {
      setIsBtn1Active(true);
      setIsBtn2Active(true);
    } else {
      setIsBtn1Active(false);
      setIsBtn2Active(false);
    }
  }, [addLocation, lobSelectedValue, productSelectedValue]);

  useEffect(() => {
    getLocationList()
      ?.then((response) => {
        if (response?.success) {
          setDropdownData([...response?.data]);
        }
      })
      ?.catch((err) => {
        showToast(err?.response?.data?.message, "error", true);
      });
  }, []);

  return (
    <div>
      <Box sx={{ width: "auto" }}>
        <Grid container spacing={5}>
          <Grid item xs={lobSelectedValue?.length > 2 ? 4 : 2}>
            <VendorSelect
              name="LOB"
              MenuButtons
              id="LOB"
              value={lobSelectedValue}
              options={LobData}
              placeholder="Select"
              required
              label="LOB"
              onChange={setLobSelectedValue}
            />
          </Grid>
          <Grid item xs={productSelectedValue?.length > 2 ? 4 : 2.2}>
            <VendorSelect
              name="Product"
              id="Product"
              MenuButtons
              value={productSelectedValue}
              onChange={setProductSelectedValue}
              options={ProductData}
              placeholder="Select"
              required
              label="Product Category"
            />
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: "0.2rem",
          marginTop: "1rem",
          marginBottom: "-0.5rem",
          marginLeft: "8px",
        }}
      >
        <Typography sx={{ fontSize: "1.2rem", color: "#3A3A3A" }}>
          Service Location
        </Typography>
        <Typography sx={{ fontSize: "1.2rem", color: "#E42125" }}>*</Typography>
      </Box>
      <Box
        sx={{
          width: "auto",
          marginLeft: "8px",
        }}
      >
        <Grid container sx={{ display: "flex" }}>
          {addLocation?.map((items, i) => {
            return (
              <Grid
                item
                xs={"auto"}
                key={i}
                id={i}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Grid item xs={"auto"}>
                  {formContents?.map((item) => {
                    return (
                      <CustomSelect
                        id={i}
                        sx={{ marginTop: "-0.6rem" }}
                        name={item?.name}
                        placeholderColor="#5E6366"
                        afterSx={{
                          ...dropdownStyles,
                          background: addLocation?.[i]?.[item?.name]
                            ? "white"
                            : "#ebeef8",
                          border: `1px solid ${
                            addLocation?.[i]?.[item?.name]
                              ? "#5570F1"
                              : "#ebeef8"
                          }`,
                        }}
                        placeholder={item?.placeholder}
                        customSelectValue={addLocation?.[i]?.[item?.name]}
                        options={item?.options}
                        handleChange={(e) =>
                          onChangeHandler(e?.target?.value, item?.name, i)
                        }
                        dropDownIcon={ArrowDropDown}
                        menuProps={menuProps}
                      />
                    );
                  })}
                </Grid>
                <Grid
                  item
                  xs={"auto"}
                  sx={{ marginTop: "-0.55rem", mr: "15px" }}
                >
                  <VendorSelect
                    id={i}
                    name="city"
                    MenuButtons
                    value={addLocation?.[i]?.["city"]}
                    options={[
                      ...(dropdownData?.find(
                        (obj) =>
                          obj?.state?.toLowerCase() ==
                          addLocation?.[i]?.["state"]?.toLowerCase()
                      )?.city || []),
                    ]}
                    onChange={(value) => onChangeHandler(value, "city", i)}
                    placeholder="Select City"
                  />
                </Grid>
              </Grid>
            );
          })}
          <Grid item xs={1.5}>
            <CommonButton
              label={"Add Location"}
              isColor
              onClick={() => addLocationHandler()}
              removeBorder
              isHover
              hoverColor={"#EBEEF8"}
              textColor={"#5E6366"}
              backgroundColor={"#EBEEF8"}
              fontSize={"1.2rem"}
              isEndIcon
              endIcon={<AddIcon sx={{ fontSize: "1.5rem" }} />}
              rightAlign
              sx={{
                padding: "7.5px 0px",
                height: "auto",
                marginLeft: "0px",
                marginTop: "8px",
                fontWeight: 400,
              }}
            ></CommonButton>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default ServiceDetails;
